export default __webpack_public_path__ + "images/7ae056f9c760afb8d124006309df1a79-fall_banner_mobile.webp";